import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = ["onClick"]

import { computed, reactive, ref, watch } from 'vue';
import { ChevronDownIcon, CheckCircleIcon, CheckIcon } from '@heroicons/vue/outline';

// @ts-ignore
import { directive as vClickOutside } from 'click-outside-vue3';

import { Classes } from './Classes';


export default /*#__PURE__*/_defineComponent({
  props: {
    multiple: { type: Boolean },
    options: null,
    title: null,
    modelValue: null,
    optionLabel: null,
    optionValue: null,
    classes: null,
    isLoading: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', modelValue: any): void;
  (e: 'change', modelValue: any | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  multiple?: boolean;
  options: any[];
  title: string;
  modelValue: any;
  optionLabel: ((option) => string) | string;
  optionValue: string;
  classes?: Classes;
  isLoading?: boolean
}





function conditionalClasses(condition: boolean, classes: string[]): string[] {
  return condition ? classes : [];
}

const isDropdownOpen = ref(false);

function openDropdown() {
  if (props.isLoading) return false;
  
  isDropdownOpen.value = true;
}

function closeDropdown() {
  isDropdownOpen.value = false;
}

function toggleDropdown() {
  isDropdownOpen.value ? closeDropdown() : openDropdown();
}

function getOptionLabel(option): string {
  if (typeof props.optionLabel === 'string') {
    return option[props.optionLabel];
  }
  
  if (typeof props.optionLabel === 'function') {
    return props.optionLabel(option);
  }
}

function getOptionValue(option): string | number {
  return option[props.optionValue];
}

const sortedOptions = computed(() => {
  return [];
});

function isOptionActive(option) {
  const selected = props.modelValue;
  const optionValue = getOptionValue(option);
  
  if (!props.multiple) {
    return selected === optionValue;
  } else {
    if (Array.isArray(selected)) {
      return selected.indexOf(optionValue) > -1;
    } else {
      return false;
    }
  }
}

function emitUpdate(value?) {
  emit('update:modelValue', value);
  emit('change', value);
}

function toggleSelectOption(option) {
  // closeDropdown()
  let selected = props.modelValue;
  const optionValue = getOptionValue(option);
  
  if (!props.multiple) {
    // if single option result
    
    if (optionValue !== selected) {
      emitUpdate(optionValue);
    } else {
      emitUpdate();
    }
  } else {
    // if multiply options result
    if (!Array.isArray(selected)) {
      selected = [];
    }
    
    const selectedIndex = selected.indexOf(optionValue);
    
    if (selectedIndex > -1) {
      // remove existing item
      selected.splice(selectedIndex, 1);
    } else {
      // add new item
      selected.push(optionValue);
    }
    
    emitUpdate(selected);
  }
}

watch(() => props.isLoading, (isLoading) => {
  if (isLoading) {
    closeDropdown();
  }
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.classes.root)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(__props.classes.label),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleDropdown()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(__props.classes.labelTitle)
      }, [
        _createElementVNode("span", null, _toDisplayString(__props.title), 1),
        (props.modelValue && props.modelValue.length > 0 && props.multiple)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(__props.classes.labelCounter)
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(__props.classes.labelCounterNumber)
              }, _toDisplayString(__props.modelValue.length), 3)
            ], 2))
          : _createCommentVNode("", true),
        (props.modelValue && !props.multiple)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(__props.classes.labelCounterIcon)
            }, null, 2))
          : _createCommentVNode("", true)
      ], 2),
      (!__props.isLoading)
        ? (_openBlock(), _createBlock(_unref(ChevronDownIcon), {
            key: 0,
            class: _normalizeClass([
          ...__props.classes.labelChevronIcon,
          ...conditionalClasses(isDropdownOpen.value, __props.classes.labelChevronIconOpen),
        ])
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      (__props.isLoading)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 1,
            class: _normalizeClass([...__props.classes.labelLoadingIcon]),
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24"
          }, _hoisted_3, 2))
        : _createCommentVNode("", true)
    ], 2),
    (isDropdownOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(__props.classes.dropdown)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(__props.classes.options)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: getOptionValue(option),
                class: _normalizeClass(__props.classes.option),
                onClick: ($event: any) => (toggleSelectOption(option))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(__props.classes.optionLabel)
                }, _toDisplayString(getOptionLabel(option)), 3),
                (isOptionActive(option))
                  ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                      key: 0,
                      class: _normalizeClass(__props.classes.optionIcon)
                    }, null, 8, ["class"]))
                  : _createCommentVNode("", true),
                (!isOptionActive(option))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(__props.classes.optionIcon)
                    }, null, 2))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_4))
            }), 128))
          ], 2)
        ], 2))
      : _createCommentVNode("", true)
  ], 2)), [
    [_unref(vClickOutside), closeDropdown]
  ])
}
}

})